export const CATALOG = {
  root: "catalog-root",
  searchInput: "catalog-search-input",
  searchSubmit: "catalog-search-submit",
  sortSelect: "catalog-sort-select",
  categoryFilterAll: "catalog-category-all",
  categoryFilterItem: "catalog-category-item",
  productGrid: "catalog-product-grid",
  productCard: "catalog-product-card",
  productCardName: "catalog-product-card-name",
  productCardPrice: "catalog-product-card-price",
  emptyState: "catalog-empty-state",
  pagination: "catalog-pagination",
  prevPageBtn: "catalog-prev-page",
  nextPageBtn: "catalog-next-page",
};

export const PDP = {
  root: "product-detail-root",
  name: "product-detail-name",
  sku: "product-detail-sku",
  brand: "product-detail-brand",
  price: "product-detail-price",
  taxNote: "product-detail-tax-note",
  addToCartBtn: "product-detail-add-to-cart",
  stockPill: "product-detail-stock-pill",
  description: "product-detail-description",
  specsTable: "product-detail-specs-table",
  mainImage: "product-detail-main-image",
  thumbList: "product-detail-thumb-list",
};
